import { IMapTypes, MapTypeData } from "./map.interfaces";

export const MapTypes = {
  STANDARD: "standard",
  LINER_SERVICE_MAP: "linerServiceMap",
  RAILROAD_MAP: "railRoadMap",
  RAILROAD_MAP_GBG: "railRoadMapGbg",
  BERTH_MAP: "berthMap",
};

export const mapTypes: IMapTypes = {
  standard: {
    longitude: 11.856809612903318,
    latitude: 57.6923001177307,
    zoom: 3,
    pitch: 0,
    bearing: 0,
  } as MapTypeData,
  linerServiceMap: {
    longitude: 13.499667652703483,
    latitude: 52.58043846902448,
    zoom: 5,
    pitch: 0,
    bearing: 0,
  } as MapTypeData,
  railRoadMap: {
    longitude: 11.856809612903318,
    latitude: 57.6923001177307,
    zoom: 14,
    pitch: 0,
    bearing: 0,
  } as MapTypeData,
  railRoadMapGbg: {
    longitude: 11.856809612903318,
    latitude: 57.6923001177307,
    zoom: 7,
    pitch: 0,
    bearing: 0,
  } as MapTypeData,
  berthMap: {
    longitude: 11.855233977821515,
    latitude: 57.68584326516396,
    zoom: 15,
    pitch: 70,
    bearing: 0,
  } as MapTypeData,
};
